/**
 * React Query Client - Configuration and Query Keys
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 預設 5 分鐘 stale time (資料被視為新鮮)
      staleTime: 5 * 60 * 1000,
      // 預設 30 分鐘垃圾回收時間
      gcTime: 30 * 60 * 1000,
      // 不在視窗聚焦時重新抓取
      refetchOnWindowFocus: false,
      // 不在重新連線時重新抓取
      refetchOnReconnect: false,
      // 失敗重試一次
      retry: 1,
      // 失敗重試延遲指數回退
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // mutation 失敗不重試
      retry: false,
    },
  },
});

// Query Keys 常量 - 用於統一管理快取鍵
export const queryKeys = {
  // Auth
  currentUser: ['me'],
  
  // Users
  users: {
    all: ['users'],
    directory: ['users', 'directory'],
    search: (query) => ['users', 'search', query],
    detail: (userId) => ['users', userId],
    managerChain: (userId) => ['users', userId, 'manager-chain'],
    cache: (userId) => ['users', userId, 'cache'],
  },
  
  // Forms
  forms: {
    all: ['forms'],
    list: (filters) => ['forms', 'list', filters],
    detail: (applicationId) => ['forms', applicationId],
    config: (formId, language) => ['forms', 'config', formId, language],
    types: (language) => ['forms', 'types', language],
    pending: ['forms', 'pending'],
    myForms: ['forms', 'my'],
    myPending: ['forms', 'my-pending'],
  },
  
  // i18n
  i18n: {
    locale: (lang) => ['i18n', 'locale', lang],
  },
  
  // Config
  config: {
    all: ['config'],
    file: (path) => ['config', 'file', path],
    list: (directory) => ['config', 'list', directory],
    permissions: ['config', 'permissions'],
  },
  
  // Debug
  debug: {
    approversConfig: ['debug', 'approvers-config'],
    systemStatus: ['debug', 'system-status'],
  },
  
  // Reminders
  reminders: {
    all: ['reminders'],
    list: (filters) => ['reminders', 'list', filters],
    detail: (reminderId) => ['reminders', reminderId],
    upcoming: ['reminders', 'upcoming'],
    categories: ['reminders', 'categories'],
    tags: ['reminders', 'tags'],
    frequentContacts: ['reminders', 'frequent-contacts'],
  },
};

export default queryClient;
